import { render, staticRenderFns } from "./O3D.vue?vue&type=template&id=2179490f&"
import script from "./O3D.vue?vue&type=script&lang=js&"
export * from "./O3D.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports